import ReactGA from 'react-ga4';

const GA_ID = process.env.REACT_APP_GA_ID;
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export function initAnalytics() {
  if (GA_ID) {
    ReactGA.initialize(GA_ID);
  }
  if (META_PIXEL_ID && window.fbq) {
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }
}

export function logPageView(path = window.location.pathname) {
  if (GA_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
}

export function logEvent(action, params = {}) {
  if (GA_ID) {
    ReactGA.event(action, params);
  }
}

export function trackMetaEvent(eventName, params = {}) {
  if (META_PIXEL_ID && window.fbq) {
    window.fbq('track', eventName, params);
  }
}
